// utils/url.ts
export function buildQueryString(params: Record<string, any>) {
  const usp = new URLSearchParams()

  for (const key in params) {
    const value = params[key]

    if (value !== undefined && value !== null) {
      usp.append(key, String(value))
    }
  }

  return usp.toString()
}